import { date } from './date';

export function isShortBooking(checkIn: Date, checkOut: Date): boolean {
  return date(checkOut).diff(checkIn, 'day') <= 29;
}

export function getBookingTotalAmount(
  checkIn: Date,
  checkOut: Date,
  baseAmount: number | null,
): number | null {
  const amount = baseAmount;

  if (amount === null) {
    return null;
  }

  if (isShortBooking(checkIn, checkOut)) {
    return amount;
  }

  const dateIn = new Date(checkIn);
  const dayIn = dateIn.getDate();
  const daysInMonth = new Date(dateIn.getFullYear(), dateIn.getMonth() + 1, 0).getDate();
  const dayOut = new Date(checkOut).getDate();

  const months = date(checkOut).diff(checkIn, 'M');

  if (dayIn === dayOut) {
    return months * amount;
  }

  if (dayIn > dayOut) {
    const diff = daysInMonth - dayIn + dayOut;
    const total = (months - 1) * amount + (amount / 30) * diff;
    return Math.round(total * 100) / 100;
  }

  const total = months * amount + (amount / 30) * (dayOut - dayIn);
  return Math.round(total * 100) / 100;
}

export function getBookingAmountPerNight(
  baseAmount: number | undefined | null,
  nights: number,
): number | null {
  if (baseAmount === null || baseAmount === undefined) {
    return null;
  }

  return Math.round((baseAmount / nights) * 100) / 100;
}
